import Dexie from "dexie";
export const db = new Dexie("scanned-visitors-by-exhibitor");

db.version(1).stores({
  visitors: "++serial, id, eventId, created, uploaded",
});
